// Function to check if a date is within a specified range
function isDateInRange(today, startMonth, startDay, endMonth, endDay) {
  const currentYear = today.getFullYear()

  const startDate = new Date(currentYear - 1, startMonth - 1, startDay)
  const endDate = new Date(currentYear, endMonth - 1, endDay)

  // Adjust end date if it falls in the next year
  if (endDate < startDate) {
    endDate.setFullYear(currentYear + 1)
  }

  return today >= startDate && today <= endDate
}

function updateNote(zone, code) {
  const productFormWrapper = document.querySelector("product-form");
  const productForm = document.querySelector("product-form form");
  let noteInput = document.querySelector("#note")
  const show_note = productFormWrapper.getAttribute("data-show-order-note");
  const today = new Date()
  const monthAbbreviations = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]

  const dateRanges = {
    // 3: { startDate: 2, startMonth: 12, endDate: 14, endMonth: 4 },
    // 4: { startDate: 2, startMonth: 12, endDate: 14, endMonth: 4 },
    
    // 5: { startDate: 16, startMonth: 12, endDate: 31, endMonth: 3 },
    // 6: { startDate: 23, startMonth: 12, endDate: 17, endMonth: 3 },
  }
  
  if(show_note == "true"){
    
    const range = dateRanges[zone];
    if (!range) {
      console.warn(`No date range found for zone ${zone}`);
      if(noteInput){
        productForm.removeChild(noteInput);
      }
      return
    }
  
    const isConditionMatched = isDateInRange(today, range.startMonth, range.startDate, range.endMonth, range.endDate)
  
    const { endDate, endMonth } = range
    const endYear = endMonth < today.getMonth() + 1 ? today.getFullYear() + 1 : today.getFullYear();
  
    console.log("jazbah:-", isConditionMatched, productForm, noteInput);
  
    if (isConditionMatched && productForm) {
      if (!noteInput) {
        noteInput = document.createElement("input")
        noteInput.id = "note"
        noteInput.name = "attributes[Winter Shipping]"
        noteInput.type = "text"
        productForm.appendChild(noteInput)
      }
  
      noteInput.value = `Ships on ${monthAbbreviations[endMonth - 1]} ${endDate}, ${endYear} for your area.`
    } else if (noteInput && productForm) {
      productForm.removeChild(noteInput);
    }
  
    shipmentUpdate(monthAbbreviations[endMonth - 1], endDate, isConditionMatched, code)
  }
}

function updateOutput(zone, code) {
  document.querySelectorAll(".navbar_zone_picker .main_picker .zone span").forEach((elm) => (elm.textContent = zone))
  document
    .querySelectorAll(".navbar_zone_picker .main_picker .planting span")
    .forEach((elm) => (elm.textContent = code))
  document
    .querySelectorAll(".navbar_zone_picker .input_box .output")
    .forEach((elm) => (elm.textContent = "Your Growing Zone: " + zone))
  document.querySelectorAll(".product_page_growing_zone").forEach((elm) => (elm.textContent = zone))
  document
    .querySelectorAll(".navbar_zone_picker .location_picker_form .inner_content .form_content .zip_code_input")
    .forEach((elm) => (elm.value = code))

  updateNote(zone, code)
}

let zipData = [] // Will hold the fetched data
var g_shipping_month, g_shipping_date

// Fetch the zipData from the provided URL
async function fetchZipData() {
  try {
    const response = await fetch("https://nationwideplants.com/cdn/shop/files/csvjson.json")

    if (!response.ok) {
      throw new Error("Failed to fetch zip data")
    }
    zipData = await response.json()
    // console.log("Zip data loaded successfully")
  } catch (error) {
    console.error("Error fetching zip data:", error)
  }
}

// Load saved zone from localStorage on page load
document.addEventListener("shopify:section:load", initializeLocationPicker)
document.addEventListener("DOMContentLoaded", initializeLocationPicker)

function initializeLocationPicker() {
  const savedZone = localStorage.getItem("zone")
  const savedZipCode = localStorage.getItem("zipCode")

  if (savedZone && savedZipCode) {
    updateOutput(savedZone, savedZipCode)
  } else {
    // If no saved location, auto-detect
    autoDetectLocation()
  }

  // Fetch the zip data
  fetchZipData()

  // Set up mobile wrapper functionality
  setupMobileWrapper()

  // opener
  const mobileWrapper = document.querySelector(".navbar_zone_picker")
  const mobileOpener = document.querySelector(".navbar_zone_picker .main_picker")
  const inner_content = document.querySelector(".navbar_zone_picker .location_picker_form .inner_content")

  const mobile_closer = document.querySelector(".navbar_zone_picker .location_picker_form .save_location_btn")

  document.querySelector("body").addEventListener("click", (event) => {
    if (mobileOpener.contains(event.target) || inner_content.contains(event.target)) {
      mobileWrapper.classList.add("active")
    } else {
      mobileWrapper.classList.remove("active")
    }
  })

  mobile_closer.addEventListener("click", (event) => {
    setTimeout(() => {
      mobileWrapper.classList.remove("active")
    }, 100)
  })
}

function setupMobileWrapper() {
  const mobileWrapper = document.querySelector(".navbar_zone_picker_mobile .navbar_zone_picker")
  const mobileOpener = document.querySelector(".navbar_zone_picker_mobile .navbar_zone_picker .main_picker")
  const inner_content = document.querySelector(
    ".navbar_zone_picker_mobile .navbar_zone_picker .location_picker_form .inner_content",
  )
  const mobile_closer = document.querySelector(
    ".navbar_zone_picker_mobile .navbar_zone_picker .location_picker_form .save_location_btn",
  )

  if (mobileWrapper && mobileOpener && inner_content && mobile_closer) {
    mobileWrapper.addEventListener("click", (event) => {
      if (mobileOpener.contains(event.target) || inner_content.contains(event.target)) {
        mobileWrapper.classList.add("active")
      } else {
        mobileWrapper.classList.remove("active")
      }
    })

    mobile_closer.addEventListener("click", () => {
      setTimeout(() => {
        mobileWrapper.classList.remove("active")
      }, 100)
    })
  }
}

// Function to check ZIP code and save zone
function checkZipcode(zipcode) {
  // console.log("Checking zipcode:", zipcode) // Debug log

  // Get all output elements
  const outputs = document.querySelectorAll(".navbar_zone_picker .input_box .output")

  // Ensure zipData is loaded
  if (zipData.length === 0) {
    const error = "Zip data not loaded yet. Please try again later."
    console.error(error)
    outputs.forEach((elm) => (elm.textContent = error))
    throw new Error(error)
  }

  // Find matching object
  const match = zipData.find((item) => item.zipcode.toString() === zipcode.toString())

  // console.log("Found match:", match) // Debug log

  if (match) {
    // Extract numeric part of the zone (e.g., "7" from "7b")
    const numericZone = match.zone.match(/\d+/)[0]
    // console.log("Numeric zone:", numericZone) // Debug log

    // Save to localStorage
    localStorage.setItem("zone", numericZone)
    localStorage.setItem("zipCode", match.zipcode)

    // Update UI
    updateOutput(numericZone, match.zipcode)

    // Close mobile form if open
    const mobileWrapper = document.querySelector(".navbar_zone_picker_mobile .navbar_zone_picker")
    if (mobileWrapper && mobileWrapper.classList.contains("active")) {
      setTimeout(() => {
        mobileWrapper.classList.remove("active")
      }, 100)
    }

    return true
  }
}

// Function to get user's location coordinates
function getLocation() {
  // console.log("Getting location...") // Debug log

  // Show loading state
  document
    .querySelectorAll(".navbar_zone_picker .input_box .output")
    .forEach((elm) => (elm.textContent = "Getting your location..."))

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(getZipFromCoords, showError, {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    })
  } else {
    alert("Geolocation is not supported by this browser.")
  }
}

// Function to fetch ZIP code from coordinates using Google Maps API
async function getZipFromCoords(position) {
  // console.log("Got coordinates:", position.coords) // Debug log

  const lat = position.coords.latitude
  const lng = position.coords.longitude

  // Show loading state
  document
    .querySelectorAll(".navbar_zone_picker .input_box .output")
    .forEach((elm) => (elm.textContent = "Retrieving your zip code..."))

  try {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyAO2xtTjITwCDMLmrayCDttujYQnJ48Z9Y`,
    )
    const data = await response.json()
    // console.log("Google Maps API response:", data) // Debug log

    if (data.status === "OK") {
      const addressComponents = data.results[0].address_components
      const zipComponent = addressComponents.find((comp) => comp.types.includes("postal_code"))

      if (zipComponent) {
        const zipcode = zipComponent.long_name
        // console.log("Found zipcode:", zipcode) // Debug log

        // Update all zip code inputs
        document.querySelectorAll(".zip_code_input").forEach((input) => {
          input.value = zipcode
        })

        // Try to check the zipcode
        try {
          const response = await checkZipcode(zipcode)

          // console.log("response", response)
        } catch (error) {
          console.error("Error checking zipcode:", error)
          alert(error.message)
        }
      } else {
        throw new Error("Could not determine the ZIP code for your location.")
      }
    } else {
      throw new Error(`Error retrieving ZIP code: ${data.status}`)
    }
  } catch (error) {
    console.error("Error fetching ZIP code:", error)
    document
      .querySelectorAll(".navbar_zone_picker .input_box .output")
      .forEach((elm) => (elm.textContent = error.message || "Failed to retrieve ZIP code"))
    alert(error.message || "Failed to retrieve ZIP code.")
  }
}

// Handle geolocation errors
function showError(error) {
  let message
  switch (error.code) {
    case error.PERMISSION_DENIED:
      message = "User denied the request for Geolocation."
      break
    case error.POSITION_UNAVAILABLE:
      message = "Location information is unavailable."
      break
    case error.TIMEOUT:
      message = "The request to get user location timed out."
      break
    case error.UNKNOWN_ERROR:
      message = "An unknown error occurred."
      break
  }
  alert(message)
}

// Handle form submission
function handleFormSubmit(event) {
  event.preventDefault()
  const zipcode = event.target.querySelector(".zip_code_input").value.trim()
  try {
    checkZipcode(zipcode)
  } catch (error) {
    console.error("Error checking zipcode:", error)
    alert(error.message)
  }
}

// Add event listeners for the zip code input, location button, and form submission
document.addEventListener("DOMContentLoaded", () => {
  // console.log("Setting up event listeners...") // Debug log

  // Setup form submissions
  document.querySelectorAll(".location_picker_form").forEach((form) => {
    form.addEventListener("submit", handleFormSubmit)
  })

  // Setup location buttons
  document.querySelectorAll(".use_my_location").forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault()
      getLocation()
    })
  })

  // Setup zip code input change events
  document.querySelectorAll(".zip_code_input").forEach((input) => {
    input.addEventListener("change", (event) => {
      const zipcode = event.target.value.trim()
      if (zipcode) {
        try {
          checkZipcode(zipcode)
        } catch (error) {
          console.error("Error checking zipcode:", error)
          alert(error.message)
        }
      }
    })
  })

  // Load initial data or auto-detect location
  const savedZone = localStorage.getItem("zone")
  const savedZipCode = localStorage.getItem("zipCode")
  if (savedZone && savedZipCode) {
    // console.log("Loading saved zone:", savedZone, "and zipcode:", savedZipCode)
    updateOutput(savedZone, savedZipCode)
  } else {
    // console.log("No saved location, auto-detecting...")
    autoDetectLocation()
  }

  // Fetch zip data
  fetchZipData()
})

// Call fetchZipData on load to ensure data is available
fetchZipData()

// update shipment
function shipmentUpdate(month, date, condition, code) {
  const shipmentText = document.querySelector(".shipment_output")

  g_shipping_month = month
  g_shipping_date = date

  if (shipmentText) {
    if (condition) {
      shipmentText.querySelector(".shipment_output_app").style.display = "none"
      shipmentText.querySelector(".shipment_output_custom").style.display = "inline-block"
      shipmentText.querySelector(".shipment_output_custom").innerHTML =
        `Ships to ${code} the week of ${month} ${date} for free.`
    } else {
      shipmentText.querySelector(".shipment_output_app").style.display = "inline-block"
      shipmentText.querySelector(".shipment_output_custom").style.display = "none"
    }
  }

  shipmentLineItemUpdate(g_shipping_month, g_shipping_date)
}

function shipmentLineItemUpdate(month, date) {
  const shipmentLineitemTexts = document.querySelectorAll(".shipment_output_custom_line")

  if (!month || !date || isNaN(date)) {
    shipmentLineitemTexts.forEach((elm) => (elm.innerHTML = ""))
  } else {
    // Get the current date
    const today = new Date()
    const currentMonth = today.toLocaleString("default", { month: "long" })
    const currentDate = today.getDate()

    let message

    if (month === currentMonth && date == currentDate) {
      message = `Ships on <span>1-3 days</span>`
    } else {
      const weekNumber = Math.ceil(date / 7)

      // Determine ordinal suffix
      let suffix = "th"
      if (weekNumber % 100 < 11 || weekNumber % 100 > 13) {
        if (weekNumber % 10 === 1) suffix = "st"
        else if (weekNumber % 10 === 2) suffix = "nd"
        else if (weekNumber % 10 === 3) suffix = "rd"
      }

      message = `Ships the week of <span>${month} ${weekNumber}${suffix}</span>`
    }

    if (shipmentLineitemTexts.length) {
      shipmentLineitemTexts.forEach((elm) => (elm.innerHTML = message))
    }
  }
}

// New function to automatically detect user's location
function autoDetectLocation() {
  // console.log("Auto-detecting location using IP...")
  // Skip geolocation and directly use IP-based location
  getApproximateLocationFromIP()
}

// New function to get approximate location from IP
async function getApproximateLocationFromIP() {
  try {
    const response = await fetch("https://ipapi.co/json/")
    const data = await response.json()
    if (data.postal) {
      // console.log("Approximate zip code from IP:", data.postal)
      document.querySelectorAll(".zip_code_input").forEach((input) => {
        input.value = data.postal
      })
      checkZipcode(data.postal)
    } else {
      throw new Error("Could not determine zip code from IP")
    }
  } catch (error) {
    console.error("Error getting location from IP:", error)
  }
}

// cart page order note
document.addEventListener("DOMContentLoaded", function () {
  cartPageOrderNote();

  setTimeout(()=>{
    cartPageOrderNote();
  }, 1000);
});

document.addEventListener("shopify:section:load", function () {
  cartPageOrderNote();

  setTimeout(()=>{
    cartPageOrderNote();
  }, 1000);
});
function cartPageOrderNote () {
  const recomendations = document.querySelector(".cart .cart-page-recommendations");

  if(recomendations){
    const chooseBtns = recomendations.querySelectorAll("carousel-slider .card__info .js-quick-add");
    const savedZone = localStorage.getItem("zone");
    const savedZipCode = localStorage.getItem("zipCode");

    chooseBtns.forEach((btn)=>{
      btn.addEventListener("click", ()=>{
        setTimeout(()=>{
          updateNote(savedZone, savedZipCode);
        }, 1000)
      })
    })
  }
}

